import { CompanyData } from '../../types/constants';

import sideProject_bg from './../../assets/img/sideproject_bg.jpg';
import { projects } from './projects';

export const sideProjectsData: CompanyData = {
  id: 0,
  name: 'Side Projects',
  country: '',
  bg: sideProject_bg,
  position: '',
  time: '',
  description:
    'As I am involved in a dynamic industry, it is essential to be equipped with latest technologies and trends. Developing side projects helps to keep my knowledge fresh and enhance the expertise.  In my leisure time, I have developed a few of my ideas into working applications.',
  projects: projects,
};
